import { Inject, Injectable } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import {
  parseTicketType,
  TicketSelectorOptions,
  TicketType,
} from '@nx-ng/types';
import { hydrate, reorder } from './ticket-selector.util';

@Injectable()
export class TicketSelectorService {
  constructor(@Inject(I18NEXT_SERVICE) private i18n: ITranslationService) {}

  public getOrderedSelection(): TicketSelectorOptions {
    const mostPopular = this.i18n.t('ticket_type_most_popular', {
      ns: 'config',
    });
    const parsedConfig = parseTicketType(mostPopular);
    // Default order
    let order: TicketType[] = ['ticketOrPass', 'flexible', 'payAsYouGo'];
    if (parsedConfig) {
      order = reorder(parsedConfig, order);
    }
    const final = hydrate(order);
    return {
      popular: final[0],
      others: final.slice(1),
    };
  }
}
